/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlockDateApiResponse } from '../models/BlockDateApiResponse';
import type { BlockDateDto } from '../models/BlockDateDto';
import type { BulkCreateSlotsApiResponse } from '../models/BulkCreateSlotsApiResponse';
import type { BulkCreateSlotsDto } from '../models/BulkCreateSlotsDto';
import type { CalendarSummaryApiResponse } from '../models/CalendarSummaryApiResponse';
import type { CreateSlotApiResponse } from '../models/CreateSlotApiResponse';
import type { CreateSlotDto } from '../models/CreateSlotDto';
import type { DeleteSlotApiResponse } from '../models/DeleteSlotApiResponse';
import type { ScheduleDetailApiResponse } from '../models/ScheduleDetailApiResponse';
import type { UnblockDateApiResponse } from '../models/UnblockDateApiResponse';
import type { UpdateSlotApiResponse } from '../models/UpdateSlotApiResponse';
import type { UpdateSlotDto } from '../models/UpdateSlotDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppAvailabilityService {
    /**
     * Get calendar summary for a month
     * Returns per-day counts of bookings, availability slots, and blocked dates for the specified month. Used to render dots/indicators on the month calendar.
     * @param startDate Start of the range as a full ISO-8601 UTC timestamp. For a local month view, send local month-start converted to UTC.
     * @param endDate End of the range (exclusive) as a full ISO-8601 UTC timestamp. For a local month view, send local next-month-start converted to UTC.
     * @returns CalendarSummaryApiResponse Calendar summary fetched successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerGetCalendarSummaryV1(
        startDate: string,
        endDate: string,
    ): CancelablePromise<CalendarSummaryApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/availability/calendar',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * Get schedule detail for a date range
     * Returns bookings (sessions) and availability slots grouped by date. Use for day view (single date) or week view (7-day range).
     * @param startDate Range start as a full ISO-8601 UTC timestamp. For a local day view, send local midnight converted to UTC.
     * @param endDate Range end (exclusive) as a full ISO-8601 UTC timestamp. Defaults to startDate + 24h if omitted.
     * @returns ScheduleDetailApiResponse Schedule fetched successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerGetScheduleDetailV1(
        startDate: string,
        endDate?: string,
    ): CancelablePromise<ScheduleDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/availability/schedule',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * Create availability slots
     * Expert adds one logical availability time window on a specific date with one or more supported modes. Validates for overlaps with existing slots and sessions, and checks blocked dates.
     * @param requestBody
     * @returns CreateSlotApiResponse Availability slots created successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerCreateSlotV1(
        requestBody: CreateSlotDto,
    ): CancelablePromise<CreateSlotApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/availability/slots',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input or blocked date`,
                409: `Overlapping slot or session`,
            },
        });
    }
    /**
     * Bulk create availability slots
     * Create many pre-computed availability slots in one request. The client expands a weekly pattern into per-day slot specs (the server does no timezone math). With dryRun=true, validates and rehearses the batch without persisting (preview). Partial success: creatable slots are created and conflicting ones are reported per item.
     * @param requestBody
     * @returns BulkCreateSlotsApiResponse Bulk availability processed
     * @throws ApiError
     */
    public static expertAvailabilityControllerCreateSlotsBulkV1(
        requestBody: BulkCreateSlotsDto,
    ): CancelablePromise<BulkCreateSlotsApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/availability/slots/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
            },
        });
    }
    /**
     * Update an availability slot
     * Update the time or supported modes of an existing available slot window. Only slots with status "available" can be updated.
     * @param slotId Availability slot UUID
     * @param requestBody
     * @returns UpdateSlotApiResponse Slot updated successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerUpdateSlotV1(
        slotId: string,
        requestBody: UpdateSlotDto,
    ): CancelablePromise<UpdateSlotApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/availability/slots/{slotId}',
            path: {
                'slotId': slotId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Slot is booked or invalid input`,
                404: `Slot not found`,
                409: `Overlapping slot or session`,
            },
        });
    }
    /**
     * Delete an availability slot
     * Removes an available slot. Only slots with status "available" (not booked) can be deleted.
     * @param slotId Availability slot UUID
     * @returns DeleteSlotApiResponse Slot deleted successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerDeleteSlotV1(
        slotId: string,
    ): CancelablePromise<DeleteSlotApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/expert-app/availability/slots/{slotId}',
            path: {
                'slotId': slotId,
            },
            errors: {
                400: `Slot is booked`,
                404: `Slot not found`,
            },
        });
    }
    /**
     * Block a date
     * Expert blocks a full day, preventing new availability slots from being created on that date.
     * @param requestBody
     * @returns BlockDateApiResponse Date blocked successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerBlockDateV1(
        requestBody: BlockDateDto,
    ): CancelablePromise<BlockDateApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/availability/blocked-dates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Date already blocked`,
            },
        });
    }
    /**
     * Unblock a date
     * Removes a blocked date, allowing availability to be added again.
     * @param id Blocked date record UUID
     * @returns UnblockDateApiResponse Date unblocked successfully
     * @throws ApiError
     */
    public static expertAvailabilityControllerUnblockDateV1(
        id: string,
    ): CancelablePromise<UnblockDateApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/expert-app/availability/blocked-dates/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Blocked date not found`,
            },
        });
    }
}
